
import { defuFn } from '/app/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/app/app.config.ts"

export default defuFn(cfg0, inlineConfig)
